// extracted by mini-css-extract-plugin
export default {"emptyList":"CaseMemberListEmpty_emptyList__8RZi4"};